import Upload from './upload/Upload';
import UploadManager from './upload/UploadManager';
import Event from './upload/Event';

/**
 * This module may be running in a true Worker scope or it
 * may be running on the main thread. If the latter, we need
 * to mimic the postMessage/onmessage behavior.
 */
class FakeBackgroundThreadWorker {
  onmessage = null;
  get target() {
    return this === publicSelf ? privateSelf : publicSelf;
  }
  postMessage(data) {
    setTimeout(() => this.target.onmessage(new Event('message', data)), 1);
  }
}

function emit(type, data) {
  const message = { type, data };
  privateSelf.postMessage(message);
}

const uploadManager = new UploadManager();

let uploads = {},
  privateSelf,
  publicSelf;

if (self === self.window) {
  publicSelf = new FakeBackgroundThreadWorker();
  privateSelf = new FakeBackgroundThreadWorker();
} else {
  privateSelf = publicSelf = self;
}

privateSelf.onmessage = function(event) {
  if (typeof event.data !== 'object') {
    return;
  }

  const { type, data={} } = event.data;
  const { uploading={}, file } = data;
  const id = uploading.id;
  let upload;
  switch (type) {
    case 'START_UPLOAD':
      upload = new Upload(uploading, file, emit, uploadManager);
      uploads[id] = upload;
      uploadManager.add(upload);
      break;
    case 'STOP_UPLOAD':
      upload = uploads[id];
      upload.stop();
      delete uploads[id];
      break;
    case 'READ_IMAGE':
      upload = uploads[id];
      upload.readImage();
      break;
    case 'CLEAR_UPLOADS':
      uploads = {};
      uploadManager.clear();
      break;
  }
};

export default function() {
  if (typeof window === 'undefined') {
    throw new Error('UploadWorker should have loaded into a background thread');
  }

  return publicSelf;
}